import _classCallCheck from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/inherits";
import * as React from "react";
import { ItemComponent, CheckboxItemComponent } from "./ItemComponents";
import { block } from "../../../core";

var map = require("lodash/map");

var includes = require("lodash/includes");

var defaults = require("lodash/defaults");

var identity = require("lodash/identity");

export var AbstractItemList =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(AbstractItemList, _React$PureComponent);

  function AbstractItemList() {
    _classCallCheck(this, AbstractItemList);

    return _possibleConstructorReturn(this, _getPrototypeOf(AbstractItemList).apply(this, arguments));
  }

  _createClass(AbstractItemList, [{
    key: "isActive",
    value: function isActive(option) {
      var _this$props = this.props,
          selectedItems = _this$props.selectedItems,
          multiselect = _this$props.multiselect;

      if (multiselect) {
        return includes(selectedItems, option.key);
      } else {
        if (selectedItems.length == 0) return null;
        return selectedItems[0] == option.key;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props2 = this.props,
          mod = _this$props2.mod,
          itemComponent = _this$props2.itemComponent,
          _this$props2$items = _this$props2.items,
          items = _this$props2$items === void 0 ? [] : _this$props2$items,
          translate = _this$props2.translate,
          toggleItem = _this$props2.toggleItem,
          setItems = _this$props2.setItems,
          multiselect = _this$props2.multiselect,
          countFormatter = _this$props2.countFormatter,
          disabled = _this$props2.disabled,
          showCount = _this$props2.showCount,
          className = _this$props2.className,
          docCount = _this$props2.docCount;
      var bemBlocks = {
        container: block(mod).el,
        option: block("".concat(mod, "-option")).el
      };
      var toggleFunc = multiselect ? toggleItem : function (key) {
        return setItems([key]);
      };
      var actions = map(items, function (option) {
        var label = option.title || option.label || option.key;
        return React.createElement(itemComponent, {
          label: translate(label),
          onClick: function onClick() {
            return toggleFunc(option.key);
          },
          bemBlocks: bemBlocks,
          key: option.key,
          itemKey: option.key,
          count: countFormatter(option.doc_count),
          rawCount: option.doc_count,
          listDocCount: docCount,
          disabled: option.disabled,
          showCount: showCount,
          active: _this.isActive(option)
        });
      });
      return React.createElement("div", {
        "data-qa": "options",
        className: bemBlocks.container().mix(className).state({
          disabled: disabled
        })
      }, actions);
    }
  }]);

  return AbstractItemList;
}(React.PureComponent);
AbstractItemList.defaultProps = {
  mod: "sk-item-list",
  showCount: true,
  itemComponent: CheckboxItemComponent,
  translate: identity,
  multiselect: true,
  selectItems: [],
  countFormatter: identity
};
export var ItemList =
/*#__PURE__*/
function (_AbstractItemList) {
  _inherits(ItemList, _AbstractItemList);

  function ItemList() {
    _classCallCheck(this, ItemList);

    return _possibleConstructorReturn(this, _getPrototypeOf(ItemList).apply(this, arguments));
  }

  return ItemList;
}(AbstractItemList);
ItemList.defaultProps = defaults({
  itemComponent: ItemComponent
}, AbstractItemList.defaultProps);
export var CheckboxItemList =
/*#__PURE__*/
function (_AbstractItemList2) {
  _inherits(CheckboxItemList, _AbstractItemList2);

  function CheckboxItemList() {
    _classCallCheck(this, CheckboxItemList);

    return _possibleConstructorReturn(this, _getPrototypeOf(CheckboxItemList).apply(this, arguments));
  }

  return CheckboxItemList;
}(AbstractItemList);
CheckboxItemList.defaultProps = defaults({
  itemComponent: CheckboxItemComponent
}, AbstractItemList.defaultProps);
export var Toggle =
/*#__PURE__*/
function (_AbstractItemList3) {
  _inherits(Toggle, _AbstractItemList3);

  function Toggle() {
    _classCallCheck(this, Toggle);

    return _possibleConstructorReturn(this, _getPrototypeOf(Toggle).apply(this, arguments));
  }

  return Toggle;
}(AbstractItemList);
Toggle.defaultProps = defaults({
  itemComponent: ItemComponent,
  mod: 'sk-toggle',
  showCount: false
}, AbstractItemList.defaultProps);
export var Tabs =
/*#__PURE__*/
function (_AbstractItemList4) {
  _inherits(Tabs, _AbstractItemList4);

  function Tabs() {
    _classCallCheck(this, Tabs);

    return _possibleConstructorReturn(this, _getPrototypeOf(Tabs).apply(this, arguments));
  }

  return Tabs;
}(AbstractItemList);
Tabs.defaultProps = defaults({
  itemComponent: ItemComponent,
  mod: 'sk-tabs',
  showCount: false,
  multiselect: false
}, AbstractItemList.defaultProps);